import { Chat, PinnedChat, ThreadChat } from '@src/api/shared/community/chatApiClient';
import defaultUserIcon from '@src/assets/images/avatar/default.png';
import { TOOLTIP_DISPLAY_TIME } from '@src/features/shared/community/components/chat/chatList/ChatItemHeader';
import Tooltip from '@src/features/shared/community/components/chat/Tooltip';
import { useChannel } from '@src/hooks/useChannel';
import useTooltip from '@src/hooks/useTooltip';
import { getCommunityMemberDetailUrl } from '@src/utils/chat';
import React from 'react';
import { Link } from 'react-router-dom';

type ChatAvatarProps = {
  chat: Chat | PinnedChat | ThreadChat;
  channelVisibility?: number;
  isLoggedIn?: boolean;
};

const ChatAvatar: React.FC<ChatAvatarProps> = ({ chat, isLoggedIn = false }) => {
  const { channel } = useChannel();
  const { showTooltip, displayTooltip } = useTooltip();

  const handleClick = (
    e: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLSpanElement>,
  ) => {
    e.preventDefault();
    e.stopPropagation();
    if (!chat.can_click) {
      if (isLoggedIn) {
        return;
      }
      displayTooltip?.(TOOLTIP_DISPLAY_TIME);
      return;
    }
    window.open(
      getCommunityMemberDetailUrl(channel.code, chat, channel.visibility) ?? '',
      '_blank',
      'noopener,noreferrer',
    );
  };

  return (
    <>
      {chat.can_click && (
        <Link
          className='shrink-0'
          to={getCommunityMemberDetailUrl(channel.code, chat, channel.visibility) ?? ''}
          onClick={handleClick}
        >
          <img
            className='size-8 rounded-full object-contain'
            src={chat.avatar_url && chat.avatar_url.length > 0 ? chat.avatar_url : defaultUserIcon}
            alt=''
            role='img'
          />
        </Link>
      )}
      {!chat.can_click && (
        <span
          className='shrink-0'
          onClick={handleClick}
        >
          <img
            className='size-8 rounded-full object-contain'
            src={chat.avatar_url && chat.avatar_url.length > 0 ? chat.avatar_url : defaultUserIcon}
            alt=''
            role='img'
          />
        </span>
      )}
      {showTooltip && (
        <div className='absolute left-6 top-[47px] z-10 text-[12px]'>
          <Tooltip
            label='表示するには、ログインしてください。'
            weight='500'
          />
        </div>
      )}
    </>
  );
};

export default ChatAvatar;
